import api from '../api'

const path = require('path')

function loadData(vm) {
    let promise = new Promise(function(resove, reject) {
        api.hifs.getDirRecursiveData(vm.root, (error, data, response) => {
            if (error) {
                vm.api.errHandler(vm, error, response)
                reject(error)
            } else {
                resove(root2tree(data))
            }
        })
    })
    return promise
}

function root2tree(dir) {
    return dir2node(dir).children
}

function dir2node(dir) {
    let children = []
    if (dir.SubDirs && dir.SubDirs.length > 0) {
        for (let d of dir.SubDirs) {
            children.push(dir2node(d))
        }
    }
    if (dir.Files && dir.Files.length > 0) {
        for (let f of dir.Files) {
            children.push(file2node(f))
        }
    }
    dir.isDir = true
    return {
        text: dir.Name,
        data: dir,
        children: children,
    }
}

function file2node(file) {
    file.isDir = false
    return {
        text: file.Name,
        data: file,
    }
}

function node2Path(node) {
    if (!node) return
    let fullPath = node.text
    for (let i = node.depth; i > 0; i--) {
        fullPath = path.join(node.parent.text, fullPath)
        node = node.parent

    }
    fullPath = path.join("/", fullPath)
    return fullPath
}

function isDir(node) {
    if (node.data.isDir) return true
    return false
}

function setLatestSelectedItem(fullPath) {
    localStorage.setItem('sessions-tree-latest-selected-item', fullPath)
}

function getLatestSelectedItem() {
    return localStorage.getItem('sessions-tree-latest-selected-item')
}

function selectRoot(tree, vm) {
    tree.selected().unselect()
    let nodes = tree.getRootNode()
    if (nodes) {
        console.debug("selectRoot: collapse valid nodes: ", nodes)
        if (!nodes.length) {
            console.debug("selectRoot: call nodes.collapse cause by invalide nodes.length: ", nodes.length)
            nodes.collapse ? nodes.collapse() : null
        } else {
            nodes.forEach((node) => { node.collapse() })
        }
    }

    setLatestSelectedItem("/")
    vm.frameVisibleUpdate(true)
    console.debug("selectRoot: set curDir and curPath to /")
    vm.curDir = "/"
    vm.curPath = "/"
    return
}

function selectNodeChildren(node) {
    console.debug("selectNodeChildren: node.children:", node.children)
    console.debug("selectNodeChildren: node.$children:", node.$children)
    if (node.children) {
        for(let c of node.children) {
            console.debug("selectNodeChildren: node.children: select ", c.text)
            c.select(true)

        }
        return
    }
    if (node.$children) {
        for(let c of node.$children) {
            console.debug("selectNodeChildren: node.$children: select ", c.text)
            c.select(true)
        }
    }
}

function checkNodeChildren(node) {
    console.debug("checkNodeChildren: node.children:", node.children)
    console.debug("checkNodeChildren: node.$children:", node.$children)
    if (node.children) {
        for(let c of node.children) {
            console.debug("checkNodeChildren: node.children: select ", c.text)
            c.check()

        }
        return
    }
    if (node.$children) {
        for(let c of node.$children) {
            console.debug("checkNodeChildren: node.$children: select ", c.text)
            c.check()
        }
    }
}

function uncheckNodeChildren(node) {
    console.debug("uncheckNodeChildren: node.children:", node.children)
    console.debug("uncheckNodeChildren: node.$children:", node.$children)
    if (node.children) {
        for(let c of node.children) {
            console.debug("uncheckNodeChildren: node.children: select ", c.text)
            c.uncheck()

        }
        return
    }
    if (node.$children) {
        for(let c of node.$children) {
            console.debug("uncheckNodeChildren: node.$children: select ", c.text)
            c.uncheck()
        }
    }
}

function selectAllChildrenByFullPath(tree, fullPath) {
    console.debug("selectAllChildrenByFullPath:", fullPath)
    if (!tree || !fullPath) {
        console.warn(`selectAllChildrenByFullPath: invalid tree(${tree}) or fullPath${fullPath}`)
        return
    }
    tree.selected().unselect()
    if (fullPath === "/") {
        // tree.selected().unselect()
        let nodes = tree.getRootNode()
        console.log("nodes:", nodes)
        if (nodes) {
            nodes.forEach((n) => { n.select(true) })
        }
        return
    }

    let node = getNodeByFullPath(tree, fullPath)
    node === null ? console.debug("skip select node which is null") : selectNodeChildren(node)
}

function checkAllChildrenByFullPath(tree, fullPath) {
    console.debug("checkAllChildrenByFullPath:", fullPath)
    if (!tree || !fullPath) {
        console.warn(`checkAllChildrenByFullPath: invalid tree(${tree}) or fullPath${fullPath}`)
        return
    }
    tree.checked().uncheck()
    if (fullPath === "/") {
        let nodes = tree.getRootNode()
        console.log("nodes:", nodes)
        if (nodes) {
            nodes.forEach((n) => { n.check() })
        }
        return
    }

    let node = getNodeByFullPath(tree, fullPath)
    node === null ? console.debug("skip check node which is null") : checkNodeChildren(node)
}
function uncheckAllChildrenByFullPath(tree, fullPath) {
    console.debug("uncheckAllChildrenByFullPath:", fullPath)
    if (!tree || !fullPath) {
        console.warn(`uncheckAllChildrenByFullPath: invalid tree(${tree}) or fullPath${fullPath}`)
        return
    }
    tree.checked().uncheck()
    if (fullPath === "/") {
        let nodes = tree.getRootNode()
        console.log("nodes:", nodes)
        if (nodes) {
            nodes.forEach((n) => { n.uncheck() })
        }
        return
    }

    let node = getNodeByFullPath(tree, fullPath)
    node === null ? console.debug("skip check node which is null") : uncheckNodeChildren(node)
}


function getNodeByFullPath(tree, fullPath) {
    if (!tree || !fullPath) {
        console.warn(`getNodeByFullPath: invalid tree(${tree}) or fullPath${fullPath}`)
        return
    }
    if (fullPath === "/") {
        return null
    }

    let names = fullPath.split(path.sep)
    let nodes = tree.getRootNode()
    if (!nodes) {
        console.debug("selectNodeByFullPath: get root node from tree failed, do nothing")
    }
    let lastName = path.basename(fullPath)

    for (let name of names) {
        if (!name) continue

        // 这一层只有一个节点时, nodes 无法遍历
        if (nodes.length === undefined) {
            console.log("selectNodeByFullPath: 发现单节点层, 直接比较 nodes.text:", nodes.text)
            let node = nodes

            // 发现单节点层, 但这一层的唯一节点名字和 name 不一致, 选中上一层节点(最接近上一次选中的节点)
            if (nodes.text !== name) {
                // selectNodeAndScrollInfoView(node)
                return node
            }

            if (name === lastName) {
                // found target node!
                // selectNodeAndScrollInfoView(node)
                return node
            }

            node.expand()
            nodes = node.children

            // 该节点已经没有子节点了, 虽然没有找到最终的目标节点, 但这个是离目标节点最近的节点, 直接选中这个最近的节点
            if (!nodes) {
                // selectNodeAndScrollInfoView(node)
                return node
            }
            continue
        }

        // 这一层有多个节点, nodes 可以遍历
        for (let node of nodes) {
            if (node.text === name) {
                if (name === lastName) {
                    // found target node!
                    // selectNodeAndScrollInfoView(node)
                    return node
                }
                node.expand()
                nodes = node.children

                // 该节点已经没有子节点了, 虽然没有找到最终的目标节点, 但这个是离目标节点最近的节点, 直接选中这个最近的节点
                if (!nodes) {
                    // selectNodeAndScrollInfoView(node)
                    return node
                }
                break
            }
        }
    }
    return null
}

function selectNodeByFullPath(tree, fullPath, vm) {
    console.debug("selectNodeByFullPath: fullPath:", fullPath)
    if (!tree || !fullPath) {
        console.warn(`selectNodeByFullPath: invalid tree(${tree}) or fullPath${fullPath}`)
        return
    }
    if (fullPath === "/") {
        selectRoot(tree, vm)
        return
    }

    selectNodeAndScrollInfoView(getNodeByFullPath(tree, fullPath))
    //
    // let names = fullPath.split(path.sep)
    // let nodes = tree.getRootNode()
    // if (!nodes) {
    //     console.debug("selectNodeByFullPath: get root node from tree failed, do nothing")
    // }
    // let lastName = path.basename(fullPath)
    //
    // for (let name of names) {
    //     if (!name) continue
    //
    //     // 这一层只有一个节点时, nodes 无法遍历
    //     if (nodes.length === undefined) {
    //         console.log("selectNodeByFullPath: 发现单节点层, 直接比较 nodes.text:", nodes.text)
    //         let node = nodes
    //
    //         // 发现单节点层, 但这一层的唯一节点名字和 name 不一致, 选中上一层节点(最接近上一次选中的节点)
    //         if (nodes.text !== name) {
    //             // node.select()
    //             selectNodeAndScrollInfoView(node)
    //             return
    //         }
    //
    //         if (name === lastName) {
    //             // found target node!
    //             // node.select()
    //             selectNodeAndScrollInfoView(node)
    //             return
    //         }
    //
    //         node.expand()
    //         nodes = node.children
    //
    //         // 该节点已经没有子节点了, 虽然没有找到最终的目标节点, 但这个是离目标节点最近的节点, 直接选中这个最近的节点
    //         if (!nodes) {
    //             // node.select()
    //             selectNodeAndScrollInfoView(node)
    //             return
    //         }
    //         continue
    //     }
    //
    //     // 这一层有多个节点, nodes 可以遍历
    //     for (let node of nodes) {
    //         if (node.text === name) {
    //             if (name === lastName) {
    //                 // found target node!
    //                 // node.select()
    //                 selectNodeAndScrollInfoView(node)
    //                 return
    //             }
    //             node.expand()
    //             nodes = node.children
    //
    //             // 该节点已经没有子节点了, 虽然没有找到最终的目标节点, 但这个是离目标节点最近的节点, 直接选中这个最近的节点
    //             if (!nodes) {
    //                 // node.select()
    //                 selectNodeAndScrollInfoView(node)
    //                 return
    //             }
    //             break
    //         }
    //     }
    // }
}

function selectLatestSelectedItem(tree, vm) {
    if (!tree) {
        console.warn("selectLatestSelectedItem: invalid true:", tree)
        return
    }
    let fullPath = getLatestSelectedItem()
    if (!fullPath) {
        let firstNode = getFirstNode(tree, vm)
        // firstNode ? firstNode.select() : console.log("no item in tree to be selected")
        firstNode ? selectNodeAndScrollInfoView(firstNode) : console.log("no item in tree to be selected")
        return
    }

    selectNodeByFullPath(tree, fullPath, vm)
}

function getFirstNode(tree) {
    if (!tree) return null
    let root = tree.getRootNode()
    if (!root) {
        return null
    }

    if (root.length < 1) {
        return null
    }
    return root[0]
}
function getLastNode(tree) {
    if (!tree) return null
    let root = tree.getRootNode()
    if (!root || root.length < 1) {
        return null
    }
    return root[root.length-1]
}

// 获取选中节点的下一个节点
// 如果整棵树没有节点则返回 null
// 如果当前没有选中任何节点则返回整棵树的第一个节点
// 如果当前节点是同一层级的最后一个节点，则递归查找上一层节点的下一个节点，直到第一层，如果到第一层也没有则返回 null
function getNextNode(tree) {
    let selection = tree.selected()
    // 当前没有选中的节点，返回整棵树的第一个节点
    if (!selection || selection.length < 1) {
        return getFirstNode(tree)
    }

    let node = selection[0]

    // 当前选中的节点已展开并且拥有子节点, 返回子节点中的第一个节点
    if (node.expanded() && node.children && node.children.length > 0) {
        return node.children[0]
    }

    // 同一层级有下一个节点则直接返回同一层级的下一个节点
    if (node.next() !== null) {
        return node.next()
    }

    // 同一层级没有下一个节点了，递归查找上一层是否有下一个节点，直到第一层
    for (let depth = node.depth; depth > 0; depth--) {
        let p = node.parent
        if (p === null) {
            return null
        }

        if (p.next() !== null) {
            return p.next()
        }
        node = p
    }

    // 最终递归到第一层都没有下一个节点则返回 null
    return null
}

// 获取选中节点的上一个节点
// 如果整棵树没有节点则返回 null
// 如果当前没有选中任何节点则返回整棵树的最后一个节点
// 如果当前节点是同一层级的第一个节点，则返回上一层节点
function getPrevNode(tree) {
    let selection = tree.selected()

    // 当前没有选中的节点，返回整棵树的最后一个节点，如果整棵树没有节点则返回 null
    if (!selection || selection.length < 1) {
        return getLastNode(tree)
    }

    let node = selection[0]
    // 当前节点是同一层级的第一个节点，返回上一层节点， 如果 node.parent 为 null 则说明是第一层，也是直接返回 null 即可
    if (node.prev() === null) {
        return node.parent
    }

    // 如果同一层级的上一个节点存在且该节点已展开，则递归找到其最后一个节点
    if (node.prev() !== null && node.prev().expanded()) {
        let last = getLastChildren(node.prev())
        if (last === null) {
            return node.prev
        }
        while (last.expanded()) {
            last = getLastChildren(last)
        }

        return last
    }

    return node.prev()
}

// 获取一个节点的 children 节点的最后一个
function getLastChildren(node) {
    if (!node || !node.children || node.children.length < 1) {
        return null
    }

    return node.children[node.children.length - 1]
}

function selectNextNode(tree) {
    let nextNode = getNextNode(tree)
    if (nextNode) {
        tree.selected().unselect()
        // nextNode.select()
        selectNodeAndScrollInfoView(nextNode)
    } else {
        console.log("no next node to be selected")
    }
}

function selectPrevNode(tree) {
    let prevNode = getPrevNode(tree)
    if (prevNode) {
        tree.selected().unselect()
        // prevNode.select()
        selectNodeAndScrollInfoView(prevNode)
        prevNode.vm.$el.scrollIntoView()
    } else {
        console.log("no prev node to be selected")
    }
}

function expandCurNode(tree) {
    let selection = tree.selected()
    if (!selection || selection.length < 1) {
        return
    }
    selection.expand()
}

function collapseCurNode(tree) {
    let selection = tree.selected()
    if (!selection || selection.length < 1) {
        return
    }

    selection.collapse()
}

// 搜索并选中第一个匹配项
// 如果没有选中项则选中第一项
function search(tree, pattern) {
    let re = new RegExp(pattern)
    let selection = tree.find(re)
    if (!selection || selection.length < 1) {
        return
    }
    selection.forEach((node) => { selectNodeAndScrollInfoView(node) })
}

function nodeScrollIntoView(node) {
    if (!node) {
        // console.debug("nodeScrollIntoView: invalid node:", node)
        return
    }

    // console.debug("nodeScrollIntoView: node:", node)
    // console.debug("nodeScrollIntoView: node.vm:", node.vm)
    if (node.vm === undefined) {
    //   console.debug("nodeScrollIntoView: select by timeout")
      setTimeout(() => {
        // console.debug("nodeScrollIntoView: select in timeout")
        // console.debug("nodeScrollIntoView: timeout node.vm:", node.vm)
        node.vm.$el.scrollIntoView()}, 200)
    } else {
    //   console.debug("nodeScrollIntoView: select directly")
      node.vm.$el.scrollIntoView()
    }
}

function deleteSelectedNodes(tree, vm) {
    if (!tree) {
        console.warn("deleteSelectedNodes: invalid tree:", tree)
        return
    }

    let delNodes = tree.checked()
    if (!delNodes || delNodes.length < 1) {
        delNodes = tree.selected()
    }

    if (!delNodes || delNodes.length < 1) {
        console.log("deleteSelectedNodes: no checked/selected node to be deleted")
        return
    }

    for (let i = 0; i < delNodes.length; i++) {
        let node = delNodes[i]
        console.log("deleteSelectedNodes: deleting node:", node)
        let relPath = path.join(vm.env.sess.basePath, node2Path(node))
        console.log("deleteSelectedNodes: relPath:", relPath)

        if (isDir(node)) {
            console.log("deleteSelectedNodes: deleting dir node:", node)
            vm.api.hifs.deleteDir(relPath, (error, data, response) => {
                if (error) {
                    vm.api.errHandler(vm, error, response)
                } else {
                    console.log("deleteSelectedNodes: deleteDir success: data", data)
                }
            })
        } else {
            vm.api.hifs.deleteFile(relPath, (error, data, response) => {
                if (error) {
                    vm.api.errHandler(vm, error, response)
                } else {
                    console.log("deleteSelectedNodes: deleteFile success: data", data)
                    if (i === delNodes.length - 1) {
                        vm.$message.success(`成功删除 ${delNodes.length} 项`)
                    }
                }
            })
        }
    }

    delNodes.remove()
}

let selClipboard = undefined
let selClipType = undefined // "cut"/"copy"
function cutSelected(tree, vm) {
    selClipboardUpdate(tree, vm)
    selClipType = "cut"
    vm.$message.success(`剪切 ${selClipboard.length} 项到会话粘贴板`)
}

function copySelected(tree, vm) {
    selClipboardUpdate(tree, vm)
    selClipType = "copy"
    vm.$message.success(`复制 ${selClipboard.length} 项到会话粘贴板`)
}

function selClipboardUpdate(tree, vm) {
    if (!tree) {
        vm.$message.warning("Invalid tree")
        return
    }

    let chkNodes = tree.checked()
    if (chkNodes && chkNodes.length > 0) {
        console.debug("selClipboard:", selClipboard)
        // console.debug("selClipboard.length:", selClipboard.length)
        selClipboard = chkNodes
        return
    }

    let selNodes = tree.selected()
    if (!selNodes || selNodes.length < 1) {
        vm.$message.warning("当前未选中会话或目录")
        return
    }

    selClipboard = selNodes
    console.debug("selClipboard:", selClipboard)
    // console.debug("selClipboard.length:", selClipboard.length)
}

// pasteClipboard 将粘贴板中的内容粘贴到当前选中的路径下
// 如果当前没有选中任何路径, 则粘贴到根路径
// 如果当前选中的第一个 node 是目录, 则粘贴到这个 node 下
// 如果当前选中的第一个 node 不是目录, 且这个 node 在根路径下, 则粘贴到根路径
// 如果当前选中的第一个 node 不是目录, 且这个不在根路径下, 则粘贴到该节点所在的目录中
function pasteClipboard(tree, vm) {
    if (!selClipType) {
        vm.$message.warning("会话粘贴板中没有内容")
        return
    }
    if (!tree) {
        vm.$message.warning("Invalid tree")
        return
    }

    let pasteDir = "/"
    let selection = tree.selected()
    // 当前没有选中的节点，粘贴到根路径
    if (!selection || selection.length < 1) {
        console.log("当前没有选中的节点，粘贴到根路径")
    } else {
        let node = selection[0]
        if (isDir(node)) {
            pasteDir = node2Path(node)
        } else {
            pasteDir = node.parent === null ? "/" : node2Path(node.parent)
        }
    }
    selection.unselect()
    let count = 0
    selClipboard.forEach((node) => {
        let src = path.join(vm.env.sess.basePath, node2Path(node))
        let dst = path.join(vm.env.sess.basePath, pasteDir, node.text)
        console.debug(`pasteClipboard: ${src} --${selClipType}--> ${dst}`)
        // console.debug("pasteClipboard: ", node2Path(node), `- ${selClipType} -> `, path.join(pastedDir, node.text))
        // vm.$message.success("pasteClipboard: ", node2Path(node), "  -> ", path.join(pastedDir, node.text))
        if (selClipType === "cut") {
            api.hifs.rename(src, dst, (error, data, response) => {
                if (error) {
                    vm.api.errHandler(vm, error, response)
                    return
                }
                console.debug(`pasteClipboard: ${src} -${selClipType}-> ${dst} success! return data: ${data}`)
                count++
                if (count === selection.length) {
                    setLatestSelectedItem(dst)
                    vm.$emit("refreshRequest")
                    vm.$message.success(`成功移动 ${count} 项`)
                }
            })
        }
        if (selClipType === "copy") {
            api.hifs.copy(src, dst, (error, data, response) => {
                if (error) {
                    vm.api.errHandler(vm, error, response)
                    return
                }
                console.debug(`pasteClipboard: ${src} -${selClipType}-> ${dst} success! return data: ${data}`)
                count++
                if (count === selection.length) {
                    setLatestSelectedItem(dst)
                    vm.$emit("refreshRequest")
                    vm.$message.success(`成功复制 ${count} 项`)
                }
            })
        }
    })
}

// newDir 创建目录
// 如果当前没有选中任何节点，则创建到会话根路径下
// 如果当前选中的节点是目录，则创建到选中的目录下
// 如果当前选中的节点不是目录，且当前选中的节点在会话根路径下（parent 节点为 null），则创建到会话根路径下
// 如果当前选中的节点不是目录，且当前选中的节点不再会话根路径下，则创建到当前选中节点的同级目录中
function newDir(tree, vm) {
    if (!tree) {
        console.debug("newDir: invalid tree:", tree)
        return
    }

    let pNode = undefined
    let children = []
    let selNodes = tree.selected()
    tree.selected().unselect()
    if (!selNodes || selNodes.length < 1) {
        pNode = tree
        children = tree.getRootNode()
    } else {
        let n = selNodes[0]
        if (isDir(n)) {
            pNode = n
            children = pNode.children
        } else {
            if (!n.parent) {
                pNode = tree
                children = tree.getRootNode()
            } else {
                pNode = n.parent
                children = pNode.children
            }
        }
    }

    if (!pNode) {
        vm.$message.error("Get parent node failed")
        return
    }

    let dir = {}
    dir.isDir = true
    dir.Name = newDirName(children)
    let dirNode = {
        text: dir.Name,
        data: dir,
        state: { selected: true}
    }

    pNode.prepend(dirNode)
    pNode.expand ? pNode.expand() : console.debug("skip expand root node")
    setTimeout(() => {
        let dst = path.join(vm.env.sess.basePath, node2Path(tree.selected()[0])) // String | 需要创建的目录的完整路径
        api.hifs.postDir(dst, (error, data, response) => {
            if (error) {
                api.errHandler(vm, error, response)
                return
            }
            console.log(`create dir(${dst}) in server success!`)
            tree.selected()[0].startEditing()
        });

    }, 0)
}

function newDirName(nodes) {
    let defaultName = "新建文件夹"
    if (!nodes || nodes.length < 1) {
        return defaultName
    }

    let tryName = defaultName
    let tryTimes = 0

    let found = false
    while(!found) {
        found = true
        for (let node of nodes) {
            if (node.text === tryName) {
                tryName = `${defaultName} ${++tryTimes}`
                found = false
                break
            }
        }
    }
    return tryName
}

function selectNodeAndScrollInfoView(node) {
    expandToNode(node)
    node ? node.select() : console.log("selectNodeAndScrollInfoView: skip select node which is invalid: ", node)
    nodeScrollIntoView(node)
}

// expand all parent of the node to make sure all parents of the node are expanded
function expandToNode(node) {
    if (!node || node === null) {
        // console.debug("expandToNode: invalid node")
        return
    }

    let p = node.parent
    if (!p || p === null) {
        // console.debug("expandToNode: invalid parent node")
        return
    }
    p.expand()
    expandToNode(p)
}

export default {
    loadData,
    root2tree,
    dir2node,
    file2node,
    node2Path,
    isDir,
    setLatestSelectedItem,
    selectLatestSelectedItem,
    selectNodeByFullPath,
    selectAllChildrenByFullPath,
    selectNextNode,
    selectPrevNode,
    checkAllChildrenByFullPath,
    uncheckAllChildrenByFullPath,
    expandCurNode,
    expandToNode,
    collapseCurNode,
    search,
    deleteSelectedNodes,
    cutSelected,
    copySelected,
    pasteClipboard,
    // nodeScrollIntoView,
    newDir,
}
